import styles from "./CommonFields.module.css";
import { Checkbox, RangeSlider, Select } from "@shopify/polaris";
import CustomInputWithUnit from "../../../components/CustomInputWithUnit/CustomInputWithUnit";
import { BBProductCardSizes, BundleTypes, FontStyles, ImageDisplays, ImageSizes } from "../constants";
import { Field } from "@shopify/react-form";
import NewCustomColorPicker from "../../../components/NewCustomColorPicker/NewCustomColorPicker";

import FormSubSection from "./FormSubSection";
import useBundleBuilderMixpanelHook from "../BundleBuilder/hooks/useBundleBuilderMixpanelHook";
interface Props_ProductCard {
    dispatchBundleConfig: (action: any) => void;
    cardName?: string | null;
    bundleType: any;

    // Optional fields
    product_background_color?: Field<string> | null;
    product_border_color?: Field<string> | null;
    product_card_desktop_size?: Field<string> | null;
    product_card_mobile_size?: Field<string> | null;
    border_width?: Field<number> | null;
    border_radius?: Field<number> | null;
    product_name_style?: Field<string> | null;
    product_name_size?: Field<number> | null;
    product_price_color?: Field<string> | null;
    product_name_color?: Field<string> | null;
    product_price_style?: Field<string> | null;
    product_price_size?: Field<number> | null;
    product_img_size?: Field<string> | null;
    product_img_show?: Field<string> | null;
    product_custom_img_size?: Field<any> | null;
    product_custom_img_size_mobile?: Field<any> | null;
    product_img_border_radius?: Field<number> | null;
    highlighted_price_tag_style?: Field<string> | null;
    highlighted_price_tag_size?: Field<number> | null;
    highlighted_price_tag_color?: Field<string> | null;

    special_text_bg_opacity?: Field<any> | null;
    product_img_border_width?: Field<any> | null;
    product_img_border_color?: Field<any> | null;
    add_to_cart_border_radius?: Field<number> | null;
    variant_selector_text_color?: Field<string> | null;
    variant_selector_text_size?: Field<number> | null;
    variant_selector_text_style?: Field<string> | null;
    swatches_select_color?: Field<string>;
    popup_heading_color?: Field<string> | null;
    popup_cta_bg_color?: Field<string> | null;
    popup_bg_color?: Field<string> | null;
    popup_text_color?: Field<string> | null;
    add_to_cart_bg_color?: Field<string>;
    add_to_cart_border_color?: Field<string>;
    add_to_cart_text_color?: Field<string>;
    add_to_cart_text_style?: Field<string> | null;
    add_to_cart_text_size?: Field<number> | null;
    add_button_bg_color?: Field<string>;
    add_button_text_color?: Field<string>;
    add_button_text_size?: Field<number>;
    add_button_text_style?: Field<string>;
    add_button_border_color?: Field<string>;
    add_button_border_width?: Field<number>;
    add_button_border_radius?: Field<number>;
    added_quantity_bg_color?: Field<string> | null;
    added_quantity_text_color?: Field<string> | null;
    added_quantity_text_style?: Field<string> | null;
    added_quantity_text_size?: Field<number> | null;
    fbt_show_checkboxes?: Field<any>;
}

const DesignProductCard = ({
    dispatchBundleConfig,
    bundleType,
    product_background_color = null,
    product_border_color = null,
    product_card_desktop_size,
    product_card_mobile_size,
    border_width = null,
    border_radius = null,
    product_name_style = null,
    product_name_size = null,
    product_price_color = null,
    product_name_color = null,
    product_price_style = null,
    product_price_size = null,
    product_img_size = null,
    product_img_show = null,
    product_custom_img_size = null,
    product_custom_img_size_mobile = null,
    highlighted_price_tag_style = null,
    highlighted_price_tag_size = null,
    highlighted_price_tag_color = null,
    // product_img_border_radius = null,
    // special_text_bg_opacity = null,
    // product_img_border_width = null,
    product_img_border_color = null,
    add_to_cart_border_radius = null,
    variant_selector_text_size,
    variant_selector_text_style,
    variant_selector_text_color,
    swatches_select_color,
    popup_bg_color,
    popup_cta_bg_color,
    popup_heading_color,
    popup_text_color,
    add_to_cart_bg_color,
    add_to_cart_text_color,
    add_to_cart_text_style,
    add_to_cart_text_size,
    add_button_bg_color,
    add_button_text_color,
    add_button_text_size,
    add_button_text_style,
    add_button_border_color,
    add_button_border_width,
    add_button_border_radius,
    added_quantity_bg_color,
    added_quantity_text_color,
    added_quantity_text_style,
    added_quantity_text_size,
    fbt_show_checkboxes,
}: Props_ProductCard) => {
    const { trackBbUpsellButton } = useBundleBuilderMixpanelHook();

    return (
        <div>
            {(product_border_color ||
                product_img_border_color ||
                product_background_color ||
                product_card_mobile_size ||
                product_card_desktop_size ||
                border_width ||
                border_radius ||
                fbt_show_checkboxes) && (
                <div id="product-card-general">
                    <FormSubSection rowLabel={"General"}>
                        {product_background_color && (
                            <NewCustomColorPicker
                                hexColor={product_background_color.value}
                                setHexColor={(val) => {
                                    product_background_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_background_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...product_background_color,
                                    onBlur: () => product_background_color?.runValidation(),
                                }}
                            />
                        )}
                        {product_border_color && (
                            <NewCustomColorPicker
                                hexColor={product_border_color.value}
                                setHexColor={(val) => {
                                    product_border_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_border_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Card Border Color"}
                                props={{ ...product_border_color, onBlur: () => product_border_color?.runValidation() }}
                            />
                        )}
                        {product_img_border_color && (
                            <NewCustomColorPicker
                                hexColor={product_img_border_color.value}
                                setHexColor={(val) => {
                                    product_img_border_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_img_border_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Image Border Color"}
                                props={{
                                    ...product_img_border_color,
                                    onBlur: () => product_img_border_color?.runValidation(),
                                }}
                            />
                        )}
                        {product_img_size && (
                            <Select
                                label={"Image Size"}
                                options={ImageSizes}
                                onChange={(val) => {
                                    product_img_size.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_img_size: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={product_img_size.value}
                            />
                        )}
                        {product_custom_img_size && (
                            <span className={styles.rangeSliderOverride}>
                                <RangeSlider
                                    min={40}
                                    max={400}
                                    label={"Image Height"}
                                    value={product_custom_img_size.value}
                                    onChange={(val) => {
                                        product_custom_img_size.onChange(val as any);
                                        dispatchBundleConfig({
                                            payload: {
                                                product_custom_img_size: val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    suffix={(product_custom_img_size.value || 0) + "px"}
                                    output
                                    error={product_custom_img_size.error}
                                />
                            </span>
                        )}
                        {product_custom_img_size_mobile && (
                            <span className={styles.rangeSliderOverride}>
                                <RangeSlider
                                    min={40}
                                    max={400}
                                    label={"Image Height Mobile"}
                                    value={product_custom_img_size_mobile.value}
                                    onChange={(val) => {
                                        product_custom_img_size_mobile.onChange(val as any);
                                        dispatchBundleConfig({
                                            payload: {
                                                product_custom_img_size_mobile: val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    suffix={(product_custom_img_size_mobile.value || 0) + "px"}
                                    output
                                    error={product_custom_img_size_mobile.error}
                                />
                            </span>
                        )}
                        {product_img_show && (
                            <Select
                                label={"Image Display"}
                                options={ImageDisplays}
                                onChange={(val) => {
                                    product_img_show.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_img_show: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={product_img_show.value}
                            />
                        )}
                        {product_card_desktop_size && (
                            <Select
                                label={"Product Card Desktop Size"}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: val,
                                        key: "product_card_desktop_size",
                                    });
                                    trackBbUpsellButton({ cta: "Product Card Desktop Size", ctaType: val });
                                    product_card_desktop_size.onChange(val);
                                }}
                                value={product_card_desktop_size.value}
                                options={BBProductCardSizes}
                            />
                        )}
                        {product_card_mobile_size && (
                            <Select
                                label={"Product Card Mobile Size"}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: val,
                                        key: "product_card_mobile_size",
                                    });
                                    trackBbUpsellButton({ cta: "Product Card Mobile Size", ctaType: val });
                                    product_card_mobile_size.onChange(val);
                                }}
                                value={product_card_mobile_size.value}
                                options={BBProductCardSizes}
                            />
                        )}
                        {border_width && (
                            <CustomInputWithUnit
                                min={1}
                                label={"Border Width"}
                                placeholder={"border width"}
                                setValue={(val) => {
                                    border_width.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            border_width: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={border_width.value}
                                unitSuffix={"px"}
                                props={{ ...border_width, onBlur: () => border_width.runValidation() }}
                            />
                        )}
                        {border_radius && (
                            <span className={styles.rangeSliderOverride}>
                                <RangeSlider
                                    min={0}
                                    max={100}
                                    label={"Border Radius"}
                                    value={border_radius.value}
                                    onChange={(val) => {
                                        border_radius.onChange(+val);
                                        dispatchBundleConfig({
                                            payload: {
                                                border_radius: +val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    output
                                    suffix={(border_radius.value || 0) + "px"}
                                    error={border_radius.error}
                                    onBlur={() => border_radius?.runValidation()}
                                />
                            </span>
                        )}
                        {fbt_show_checkboxes && (
                            <Checkbox
                                label={`${
                                    bundleType == "product_add_on"
                                        ? "Show Checkboxes on Products"
                                        : "Show Checkboxes on Image"
                                }`}
                                {...fbt_show_checkboxes}
                                value=""
                                checked={+fbt_show_checkboxes?.value == 1}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: val ? 1 : 0,
                                        key: "fbt_show_checkboxes",
                                    });
                                    fbt_show_checkboxes.onChange(val ? 1 : 0);
                                }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}

            {(product_name_color || product_name_size || product_name_style) && (
                <div id="product-card-name">
                    <FormSubSection rowLabel={"Title"}>
                        {product_name_color && (
                            <NewCustomColorPicker
                                hexColor={product_name_color.value}
                                setHexColor={(val) => {
                                    product_name_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_name_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...product_name_color, onBlur: () => product_name_color?.runValidation() }}
                            />
                        )}
                        {product_name_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    product_name_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_name_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={product_name_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...product_name_size,
                                    onBlur: () => product_name_size?.runValidation(),
                                }}
                            />
                        )}
                        {product_name_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    product_name_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_name_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={product_name_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}

            {(highlighted_price_tag_size || highlighted_price_tag_style || highlighted_price_tag_color) && (
                <div id="product-card-price">
                    <FormSubSection rowLabel={"Price"}>
                        {highlighted_price_tag_color && (
                            <NewCustomColorPicker
                                hexColor={highlighted_price_tag_color.value}
                                setHexColor={(val) => {
                                    highlighted_price_tag_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            highlighted_price_tag_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Product Price Color"}
                                props={{
                                    ...highlighted_price_tag_color,
                                    onBlur: () => product_name_color?.runValidation(),
                                }}
                            />
                        )}
                        {highlighted_price_tag_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Product Price Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    highlighted_price_tag_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            highlighted_price_tag_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={highlighted_price_tag_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...highlighted_price_tag_size,
                                    onBlur: () => highlighted_price_tag_size?.runValidation(),
                                }}
                            />
                        )}
                        {highlighted_price_tag_style && (
                            <Select
                                label={"Product Price Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    highlighted_price_tag_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            highlighted_price_tag_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={highlighted_price_tag_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}

            {(product_price_size || product_price_style || product_price_color) && (
                <div id="product-card-compare-at-price">
                    <FormSubSection rowLabel={"Compare at Price"}>
                        {product_price_color && (
                            <NewCustomColorPicker
                                hexColor={product_price_color.value}
                                setHexColor={(val) => {
                                    product_price_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_price_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Compare-at Price"}
                                props={{ ...product_price_color, onBlur: () => product_price_color?.runValidation() }}
                            />
                        )}
                        {product_price_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Compare-at Price Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    product_price_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_price_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={product_price_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...product_price_size,
                                    onBlur: () => product_price_size?.runValidation(),
                                }}
                            />
                        )}
                        {product_price_style && (
                            <Select
                                label={"Compare-at Price Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    product_price_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            product_price_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={product_price_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(added_quantity_bg_color ||
                added_quantity_text_color ||
                added_quantity_text_style ||
                added_quantity_text_size) && (
                <div id="product-card-added-quantity">
                    <FormSubSection rowLabel={"Quantity Label"}>
                        {added_quantity_bg_color && (
                            <NewCustomColorPicker
                                hexColor={added_quantity_bg_color.value}
                                setHexColor={(val) => {
                                    added_quantity_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            added_quantity_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...added_quantity_bg_color,
                                    onBlur: () => added_quantity_bg_color?.runValidation(),
                                }}
                            />
                        )}
                        {added_quantity_text_color && (
                            <NewCustomColorPicker
                                hexColor={added_quantity_text_color.value}
                                setHexColor={(val) => {
                                    added_quantity_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            added_quantity_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...added_quantity_text_color,
                                    onBlur: () => added_quantity_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {added_quantity_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    added_quantity_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            added_quantity_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={added_quantity_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...added_quantity_text_size,
                                    onBlur: () => added_quantity_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {added_quantity_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    added_quantity_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            added_quantity_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={added_quantity_text_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}

            {(add_to_cart_bg_color ||
                add_to_cart_text_color ||
                add_to_cart_text_size ||
                add_to_cart_text_style ||
                add_to_cart_border_radius) && (
                <div id="product-card-add-to-cart">
                    <FormSubSection rowLabel={"CTA"}>
                        {add_to_cart_bg_color && (
                            <NewCustomColorPicker
                                hexColor={add_to_cart_bg_color.value}
                                setHexColor={(val) => {
                                    add_to_cart_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_to_cart_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{ ...add_to_cart_bg_color, onBlur: () => add_to_cart_bg_color?.runValidation() }}
                            />
                        )}
                        {add_to_cart_text_color && (
                            <NewCustomColorPicker
                                hexColor={add_to_cart_text_color.value}
                                setHexColor={(val) => {
                                    add_to_cart_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_to_cart_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...add_to_cart_text_color,
                                    onBlur: () => add_to_cart_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {add_to_cart_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    add_to_cart_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_to_cart_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={add_to_cart_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...add_to_cart_text_size,
                                    onBlur: () => add_to_cart_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {add_to_cart_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    add_to_cart_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_to_cart_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={add_to_cart_text_style.value}
                            />
                        )}

                        {add_to_cart_border_radius && (
                            <span className={styles.rangeSliderOverride}>
                                <RangeSlider
                                    min={0}
                                    max={100}
                                    label="Radius"
                                    value={add_to_cart_border_radius.value}
                                    onChange={(val) => {
                                        add_to_cart_border_radius.onChange(+val);
                                        dispatchBundleConfig({
                                            payload: {
                                                add_to_cart_border_radius: +val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    output
                                    suffix={(add_to_cart_border_radius.value || 0) + "px"}
                                    error={add_to_cart_border_radius.error}
                                    onBlur={() => add_to_cart_border_radius?.runValidation()}
                                />
                            </span>
                        )}
                    </FormSubSection>
                </div>
            )}
            {(variant_selector_text_size ||
                variant_selector_text_style ||
                variant_selector_text_color ||
                swatches_select_color) && (
                <div id="product-card-swatches-selector">
                    <FormSubSection
                        rowLabel={"Variant Selector"}
                        hideSeparator={
                            ![
                                BundleTypes.BUNDLE_BUILDER,
                                BundleTypes.MIX_MATCH,
                                BundleTypes.MIX_MATCH_SECTIONAL,
                            ]?.includes(bundleType)
                        }
                    >
                        {variant_selector_text_color && (
                            <NewCustomColorPicker
                                hexColor={variant_selector_text_color.value}
                                setHexColor={(val) => {
                                    variant_selector_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            variant_selector_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Color"}
                                props={{
                                    ...variant_selector_text_color,
                                    onBlur: () => variant_selector_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {swatches_select_color && (
                            <NewCustomColorPicker
                                hexColor={swatches_select_color.value}
                                setHexColor={(val) => {
                                    swatches_select_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            swatches_select_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Swatches Color"}
                                props={{
                                    ...swatches_select_color,
                                    onBlur: () => swatches_select_color?.runValidation(),
                                }}
                            />
                        )}
                        {variant_selector_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    variant_selector_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            variant_selector_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={variant_selector_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...variant_selector_text_size,
                                    onBlur: () => variant_selector_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {variant_selector_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    variant_selector_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            variant_selector_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={variant_selector_text_style.value}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}
            {(popup_heading_color || popup_cta_bg_color || popup_bg_color || popup_text_color) && (
                <div id="image-popup-design">
                    <FormSubSection rowLabel={"Image Popup"} helpText={"Image Popup"} hideSeparator={true}>
                        {popup_bg_color && (
                            <NewCustomColorPicker
                                hexColor={popup_bg_color.value}
                                setHexColor={(val) => {
                                    popup_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            popup_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{ ...popup_bg_color, onBlur: () => popup_bg_color?.runValidation() }}
                            />
                        )}
                        {popup_heading_color && (
                            <NewCustomColorPicker
                                hexColor={popup_heading_color.value}
                                setHexColor={(val) => {
                                    popup_heading_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            popup_heading_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Popup Heading"}
                                props={{
                                    ...popup_heading_color,
                                    onBlur: () => popup_heading_color?.runValidation(),
                                }}
                            />
                        )}

                        {popup_text_color && (
                            <NewCustomColorPicker
                                hexColor={popup_text_color.value}
                                setHexColor={(val) => {
                                    popup_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            popup_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{ ...popup_text_color, onBlur: () => popup_text_color?.runValidation() }}
                            />
                        )}
                        {popup_cta_bg_color && (
                            <NewCustomColorPicker
                                hexColor={popup_cta_bg_color.value}
                                setHexColor={(val) => {
                                    popup_cta_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            popup_cta_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Popup CTA"}
                                props={{ ...popup_cta_bg_color, onBlur: () => popup_cta_bg_color?.runValidation() }}
                            />
                        )}
                    </FormSubSection>
                </div>
            )}

            {(add_button_bg_color ||
                add_button_text_color ||
                add_button_text_size ||
                add_button_text_style ||
                add_button_border_color ||
                add_button_border_width ||
                add_button_border_radius) && (
                <div id="product-card-add-button">
                    <FormSubSection rowLabel={"Add Button"} hideSeparator={true}>
                        {add_button_bg_color && (
                            <NewCustomColorPicker
                                hexColor={add_button_bg_color.value}
                                setHexColor={(val) => {
                                    add_button_bg_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_button_bg_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Background Color"}
                                props={{
                                    ...add_button_bg_color,
                                    onBlur: () => add_button_bg_color?.runValidation(),
                                }}
                            />
                        )}
                        {add_button_text_color && (
                            <NewCustomColorPicker
                                hexColor={add_button_text_color.value}
                                setHexColor={(val) => {
                                    add_button_text_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_button_text_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Text Color"}
                                props={{
                                    ...add_button_text_color,
                                    onBlur: () => add_button_text_color?.runValidation(),
                                }}
                            />
                        )}
                        {add_button_text_size && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Size"}
                                placeholder={"font size"}
                                setValue={(val) => {
                                    add_button_text_size.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_button_text_size: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={add_button_text_size.value}
                                unitSuffix={"px"}
                                props={{
                                    ...add_button_text_size,
                                    onBlur: () => add_button_text_size?.runValidation(),
                                }}
                            />
                        )}
                        {add_button_text_style && (
                            <Select
                                label={"Style"}
                                options={FontStyles}
                                placeholder={"Font style"}
                                onChange={(val) => {
                                    add_button_text_style.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_button_text_style: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={add_button_text_style.value}
                            />
                        )}
                        {add_button_border_color && (
                            <NewCustomColorPicker
                                hexColor={add_button_border_color.value}
                                setHexColor={(val) => {
                                    add_button_border_color.onChange(val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_button_border_color: val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                label={"Border Color"}
                                props={{
                                    ...add_button_border_color,
                                    onBlur: () => add_button_border_color?.runValidation(),
                                }}
                            />
                        )}
                        {add_button_border_width && (
                            <CustomInputWithUnit
                                min={0}
                                label={"Border Width"}
                                placeholder={"border width"}
                                setValue={(val) => {
                                    add_button_border_width.onChange(+val);
                                    dispatchBundleConfig({
                                        payload: {
                                            add_button_border_width: +val,
                                        },
                                        isComplex: true,
                                        key: "bundles_design",
                                    });
                                }}
                                value={add_button_border_width.value}
                                unitSuffix={"px"}
                                props={{
                                    ...add_button_border_width,
                                    onBlur: () => add_button_border_width.runValidation(),
                                }}
                            />
                        )}
                        {add_button_border_radius && (
                            <span className={styles.rangeSliderOverride}>
                                <RangeSlider
                                    min={0}
                                    max={100}
                                    label={"Border Radius"}
                                    value={add_button_border_radius.value}
                                    onChange={(val) => {
                                        add_button_border_radius.onChange(+val);
                                        dispatchBundleConfig({
                                            payload: {
                                                add_button_border_radius: +val,
                                            },
                                            isComplex: true,
                                            key: "bundles_design",
                                        });
                                    }}
                                    output
                                    suffix={(add_button_border_radius.value || 0) + "px"}
                                    error={add_button_border_radius.error}
                                    onBlur={() => add_button_border_radius?.runValidation()}
                                />
                            </span>
                        )}
                    </FormSubSection>
                </div>
            )}
        </div>
    );
};

export default DesignProductCard;
